import $ from 'jquery';
import { toggleDropdown, showDropdown, hideAllDropdowns } from './dropdown-common';

$(() => {
    let activeLink = $('.nav__item > .nav-link-active').first();
    let activeDropdown = null;
    let activeDropdownLink = $('.dropdown__body .nav-link-active').first();

    function hideAllDropdowns() {
        $('.dropdown__body').hide();
    }

    function activateLink(link) {
        hideAllDropdowns();
        activeDropdown = null;
        $('.nav__item > .nav-link-active').each(function(index) {
            let l = $(this);
            l.removeClass('nav-link-active');
        });
        link.addClass('nav-link-active'); 
        if (link.hasClass('dropdown__trigger')) {
            
            showDropdown(link);
            activeDropdown = link;
        }
    }

    function deactivateLink(link, force = false) {
        if (force || !link.is(activeDropdown)) {
            link.removeClass('nav-link-active');    
        }
        
        setTimeout(() => {
            if ($('.nav__item > .nav-link-active').length == 0) {
                if (activeDropdown) {
                    activeDropdown.addClass('nav-link-active');       
                } else {
                    activeLink.addClass('nav-link-active');       
                }
            }
        }, 100);
    }
    
    $('.nav__item > .nav-link').hover((event) => {
        const type = event.type
        const link = $(event.target);
        if (type == 'mouseenter') {
            activateLink(link);
        } else if (type == 'mouseleave') {
            deactivateLink(link);
        }
    });

    $('.nav-link.dropdown__trigger').click((event) => {
        let dropdown = $(event.target);
        if (dropdown.is(activeDropdown)) {
            activeDropdown = null;
        } else {
            activeDropdown = dropdown;    
        } 
    });

    $('body').click(() => {
        if (activeDropdown) {
            let dropdown = activeDropdown;
            activeDropdown = null;
            deactivateLink(dropdown, true);
        }
    });

    $('.dropdown__body .nav-link').hover((event) => {
        const type = event.type;
        const link = $(event.target);
        if (type == 'mouseenter') {
            activateDropdownLink(link) 
        } else if (type == 'mouseleave') {
            deactivateDropdownLink(link)
        }
    });

    function activateDropdownLink(link) {
        $('.dropdown__body .nav-link-active').each(function(index) {
            let l = $(this);
            l.removeClass('nav-link-active');
        });
        link.addClass('nav-link-active'); 
    }

    function deactivateDropdownLink(link) {
        link.removeClass('nav-link-active'); 
        
        setTimeout(() => {
            if ($('.dropdown__body .nav-link-active').length == 0) {
                activeDropdownLink.addClass('nav-link-active'); 
            }
        }, 100);
    }
});